import FontAwesome from 'react-fontawesome';
import { FiEdit } from "react-icons/fi";
import { LuLoaderCircle } from "react-icons/lu";

import React, { useState, useEffect } from 'react';
import { Text, Flex, Box } from 'rebass';
import useSWR from 'swr';
import { Formik, Form, Field } from 'formik';
import useHistory from 'app/hooks/history';
import {
  Activity,
  LikesCommentsAvatars,
  LikesButton,
  ActivityCommentsButton,
} from './styled';
import { useToggle } from '../../app/hooks';
import { updateTextMedium } from 'story-media/api';
import Modal from 'app/modal/v2/index';
import TextForm from 'story-media/text-form/form';
import { patch } from 'utils/api';
import { rotate } from 'app/modal/BufferingOverlay';
import CheckMark from 'assets/svg/check-mark';

export function RenderTextEditingForm({
  id,
  type,
  onDismiss,
  values,
  title = "Edit Transcription"
}) {
  const { revalidate } = useSWR(`/v2/media/${id}`)
  return (
    <Modal onClose={onDismiss} closeButton bg="white" maxWidth="620px" closeButtonLeft>
      <Modal.InnerWrap style={{ padding: 0, maxWidth: '620px', margin: "auto", marginTop: '10px' }}>
        <Modal.Title>{title}</Modal.Title>
        <Box style={{ background: 'white', display: 'grid', borderRadius: '10px', paddingTop: '30px' }}>
          <Formik
            initialValues={values}
            onSubmit={async (values, { setSubmitting }) => {
              setSubmitting(true)
              await updateTextMedium(id, {
                data: {
                  attributes: {
                    ...values,
                    'lock-version': 1,
                  }
                }
              })
              revalidate()
              setSubmitting(false)
              onDismiss()
            }}
            enableReinitialize
          >
            {({ isSubmitting }) => (
              <TextForm
                name="transcription"
                isSubmitting={isSubmitting}
                onCancel={onDismiss}
              />
            )}
          </Formik>
        </Box>
      </Modal.InnerWrap>
    </Modal>
  );
}

const ShowTranscription = ({ id, medium, editing, isTranscribing, transcriptionState, transcription, showTranscription = false, type, story }) => {
  const [open, toggle] = useToggle(true);
  const [isEditing, setIsEdit] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [previousTranscriptionState, setPreviousTranscriptionState] = useState(transcriptionState);

  const transcriptionFailed = transcriptionState === 'transcription_failed';

  const [showToast, setShowToast] = useState(false);
  const { push } = useHistory();

  useEffect(() => {
    setPreviousTranscriptionState(transcriptionState)

    if (previousTranscriptionState !== null && previousTranscriptionState !== 'transcribing_tidying_up_finished' && transcriptionState === 'transcribing_tidying_up_finished') {
      setPreviousTranscriptionState(transcriptionState)
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    }
  }, [transcriptionState])

  const onDeletion = async () => {
    setSubmitting(true)
    await patch(`/v2/media/${id}`, {
      data: {
        attributes: {
          'transcription-state': 'transcription_hidden',
          'lock-version': medium?.['lock-version'],
        }
      }
    })
    setSubmitting(false)
  }

  if (transcriptionState === 'transcription_hidden')
    return null

  if (isTranscribing || transcriptionFailed)
    return <Activity style={{ background: '#F9FAFB', borderRadius: '10px', marginBottom: '20px' }}>
      <LikesCommentsAvatars>
        <ActivityCommentsButton style={{ flexDirection: 'column', cursor: transcriptionFailed && 'default' }}>
          <LikesButton className={isTranscribing && "loading"} style={{ fontWeight: 'bold', marginRight: 'auto', cursor: transcriptionFailed && 'default', color: transcriptionFailed ? 'red' : '#0E0E0E' }}>
            <Text
              as={LuLoaderCircle}
              color='#9B59B6'
              size={20}
              mr={1}
              sx={{
                animation: `${rotate} 1s linear infinite`,
                boxShadow: '1p 1px 8px rgba(0,0,0,.75)',
              }}
            />

            {transcriptionFailed ? 'Error with transcription. Please upload again.' :
              'Transcription in progress'}
          </LikesButton>
          {transcriptionFailed && <Text
            mt={1}
            onClick={isSubmitting ? undefined : onDeletion}
            ml="auto"
            fontWeight="bold"
            color="red"
            sx={{ textDecorationLine: 'underline', cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
          >Delete Message</Text>}
        </ActivityCommentsButton>
      </LikesCommentsAvatars>
    </Activity>


  if (transcription)
    return (
      <Activity>
        <LikesCommentsAvatars>
          <ActivityCommentsButton onClick={toggle}>
            {!open && (
              <LikesButton style={{ fontWeight: 400, fontFamily: 'Poppins', lineHeight: '150%', color: '#9B59B6' }}>
                View Transcription
              </LikesButton>
            )}
          </ActivityCommentsButton>
        </LikesCommentsAvatars>
        {showToast && (
          <Flex
            mt={3}
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            minWidth="260px"
            sx={{
              bg: '#E0FFEA',
              color: 'white',
              py: '10px',
              px: 3,
              borderRadius: '30px',
              position: 'fixed',
              zIndex: 9999,
              left: '50%',
              transform: 'translateX(-50%)',
              fontFamily: 'Poppins',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '150%',
              letterSpacing: '-0.096px',
              color: "#00611F",
              bottom: '100px',
            }}
          >
            <Flex width="100%" alignItems="center" justifyContent="flex-start">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.6673 5L7.50065 14.1667L3.33398 10" stroke="#00611F" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>&nbsp;
              <Text>
                Transcription complete!
              </Text>
            </Flex>

            <u style={{ cursor: 'pointer', fontWeight: 400, fontFamily: 'Poppins', lineHeight: '150%', color: '#00611F' }} onClick={() => {
              push(`/story/${story?.id}/edit?ref=${id}`)
            }}>
              <b>View {story.title ? 'in' : ''} {story.title} <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9.8055 3.71197C10.1487 3.36879 10.6922 3.3475 11.0604 3.64768L11.132 3.71197L16.757 9.33697C17.1231 9.70309 17.1231 10.2974 16.757 10.6635L11.132 16.2885C10.7659 16.6546 10.1716 16.6546 9.8055 16.2885C9.43938 15.9224 9.43938 15.3281 9.8055 14.962L13.8298 10.9377H3.90625C3.38848 10.9377 2.96875 10.518 2.96875 10.0002C2.96875 9.48245 3.38848 9.06272 3.90625 9.06272H13.8298L9.8055 5.03847L9.74121 4.96685C9.44103 4.59863 9.46232 4.05515 9.8055 3.71197Z" fill="#00611F" />
              </svg></b>
            </u>
          </Flex>
        )}
        {open && (
          isEditing ?
            <RenderTextEditingForm type={type} id={id} values={{ transcription }} onDismiss={() => setIsEdit(false)} />
            : <Flex bg="white" flexDirection="column" p="20px" pt={0} >
              <Text color="#0E0E0E" sx={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: transcription }} />

              {editing &&
                <Flex justifyContent="space-between" mt={2}>
                  <LikesButton onClick={toggle} style={{ fontWeight: 400, fontFamily: 'Poppins', lineHeight: '150%', color: '#9B59B6' }}>
                    Hide Transcription
                  </LikesButton>
                  <Flex style={{ cursor: 'pointer', fontWeight: 400, fontFamily: 'Poppins', lineHeight: '150%', color: '#9B59B6' }} onClick={() => setIsEdit(true)} >
                    Edit &nbsp;
                    <FiEdit color="#9B59B6" size={24} sx={{ cursor: 'pointer', minWidth: '24px' }} />
                  </Flex>
                </Flex>}
            </Flex>
        )
        }
      </Activity>
    );
};

ShowTranscription.propTypes = {
};

export default ShowTranscription;
